"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copyrights = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.div `
	max-width: 900px;
	margin-bottom: 16px;

	${(p) => p.theme.breakpoints.down("sm")} {
		margin: 0 auto 16px;
	}

	${(p) => p.theme.breakpoints.down("md")} {
		max-width: 600px;
	}

	.copyright {
		font-weight: 400;
		font-size: 12px;
		line-height: 22px;
		letter-spacing: 0.2px;
		color: ${(p) => p.theme.palette.text.secondary || p.theme.palette.text.primary};
		font-family: ${(p) => p.theme.fonts.default};
	}
`;
const Copyrights = ({ copyrights = [], newLineCopyrights }) => {
    const currentYear = `${new Date().getFullYear()}`;
    return (react_1.default.createElement(Styled, null, copyrights.map((copyright) => {
        let c = copyright;
        c = c.replace(/\{YEAR\}/g, currentYear);
        c = c.replace(/&copy;/g, "©");
        if (newLineCopyrights) {
            return (
            /* eslint-disable react/no-danger */
            react_1.default.createElement("div", { className: "copyright newline", key: `copyright-${c}`, dangerouslySetInnerHTML: { __html: c } }));
        }
        return (react_1.default.createElement("span", { className: "copyright", key: `copyright-${c}` },
            c,
            "\u00A0\u00A0"));
    })));
};
exports.Copyrights = Copyrights;
//# sourceMappingURL=Copyrights.molecule.js.map